import axios from "axios";
import ResourceReservation from "@/model/ResourceReservation.model";
import ReservationAggregate from "@/model/ReservationAggregate";
import { Formatter } from "@/util/Formatter";
export default class ResourceService {
    loadAllResources() {
        return axios.get('resource/all', {
            withCredentials: true
        }).then(response => response.data);
    }
    loadResources(type) {
        return axios.get('resources/' + type, {
            withCredentials: true
        }).then(response => response.data);
    }
    loadResource(id, callback) {
        axios.get('resource', {
            params: {
                id: id
            },
            withCredentials: true
        }).then(response => {
            const responseResource = response.data;
            callback(responseResource);
        });
    }
    createOrUpdateResource(resource) {
        return axios.post("/resources", resource, {
            withCredentials: true
        });
    }
    loadResourceGroup(id, callback) {
        axios.get('resourceGroup', {
            params: {
                id: id
            },
            withCredentials: true
        }).then(response => {
            const responseResource = response.data;
            callback(responseResource);
        });
    }
    createResourceGroup(resourceGroup) {
        return axios.post("/resourceGroup/create", resourceGroup, {
            withCredentials: true
        });
    }
    updateResourceGroup(resourceGroup) {
        return axios.post("/resourceGroup/update", resourceGroup, {
            withCredentials: true
        });
    }
    loadAllResourceGroups() {
        return axios.get('resourceGroup/all', {
            withCredentials: true
        }).then(response => response.data);
    }
    getResourceGroups(type) {
        return axios.get('resourceGroups/' + type, {
            withCredentials: true
        }).then(response => response.data);
    }
    loadResourceReservations(callback, resourceIds, filterFrom, filterTo) {
        axios.get('reservationsAggregate', {
            params: {
                resourceIds: resourceIds.map((n) => `${n}`).join(','),
                filterFrom: Formatter.isoDate(filterFrom),
                filterTo: Formatter.isoDate(filterTo)
            },
            withCredentials: true
        }).then(response => {
            callback(this.toTypedReservationAggregate(response.data));
        });
    }
    toTypedResourceReservations(responseData) {
        const typedReservations = [];
        // Type conversion
        responseData.forEach((entry) => {
            const resourceReservation = new ResourceReservation(entry);
            typedReservations.push(resourceReservation);
        });
        return typedReservations;
    }
    toTypedReservationAggregate(responseData) {
        const typedReservationAggregates = [];
        // Type conversion
        responseData.forEach((entry) => {
            const reservationAggregate = new ReservationAggregate(entry);
            typedReservationAggregates.push(reservationAggregate);
        });
        return typedReservationAggregates;
    }
}
